var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-41"}},[_c('LmsMssComponent',{attrs:{"endpoint":"gettaf","source":"data","header_filter":"FCSQ41","show_header":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }